export default __webpack_public_path__ + "static/media/redux.d65918af.png";